import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import "../../assets/stylesheets/error.css";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Baloon from "../../assets/image/baloon.png";

function NotFound() {
  const { t } = useTranslation(["error"]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Helmet>
      
        <meta property="og:title" content={t("errorTitle")} />
        <meta property="og:site_name" content="sievn.am" />

        <meta property="og:description" content={t("errorDescribe")} />

        <meta name="description" content={t("errorDescribe")} />

        <title>{t("errorTitle")}</title>
      </Helmet>

      <div className="containerErr">
        <div className="error">
          <div className="errorImg">
            <img src={Baloon} alt="404error" />
          </div>
          <div className="errordiv">
            <h1>404</h1>
          </div>
          <p>{t("errorOps")}</p>
          <span>
          {t("errorText")}
          </span>
          <Link to="/">
            <button>   {t("errorButton")}</button>
          </Link>
        </div>
      </div>
    </>
  );
}

export default NotFound;
